module Easypass {
    class PlatNutriscoreController {
        constructor() {
            (<any>window).DataAnalyticsSender.sendCustomEvent('Nutriscore_Screen', '');
        }
    }

    angular.module('easypass').controller('platNutriscoreController', [ PlatNutriscoreController]);
}
